import { DemoApiMock } from '../types'
import { getDemoData, matchRestRequest, setDemoData } from '../utils'
import { WorkShift, Work } from 'typings/common_defs'

interface RequestWorkersPayload {
  shift_ids: number[]
  additional_workers: number
}

export const mockAssignmentAddWorkers: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      /\/company\/\d+\/assignment\/\d+\/shifts\/add_workers/,
      'PUT'
    ),
  getResponse: async (request) => {
    const payload = request.data as RequestWorkersPayload
    const { shift_ids, additional_workers } = payload
    const demoData = getDemoData()

    // Update each affected shift
    const updatedShifts = demoData.shifts.map((s) => {
      if (!shift_ids.includes(s.id)) {
        return s
      }

      const currentShift = s as WorkShift & {
        work?: Array<Work>
      }

      return {
        ...currentShift,
        workersNeeded: (currentShift.workersNeeded ?? 0) + additional_workers,
        numOpenSpots: (currentShift.numOpenSpots ?? 0) + additional_workers, // Add to existing numOpenSpots
      }
    })

    // Update assignments to reflect new numWorkersPending
    const updatedAssignments =
      demoData.assignments?.map((assignment) => {
        const assignmentShifts = updatedShifts.filter(
          (s) => s.assignment?.id === assignment.id
        )
        if (assignmentShifts.length === 0) return assignment

        return {
          ...assignment,
          listings: [
            {
              id: assignment.id,
              numWorkersPending: Math.max(
                ...assignmentShifts
                  .filter((shift) => !shift.cancelledAt)
                  .map((shift) => shift.numOpenSpots ?? 0)
              ),
              shifts: assignmentShifts.map((shift) => ({
                id: shift.id,
                numOpenSpots: shift.numOpenSpots ?? 0,
              })),
            },
          ],
        }
      }) ?? []

    setDemoData({
      ...demoData,
      shifts: updatedShifts,
      assignments: updatedAssignments,
    })

    return {
      data: {
        success: true,
        message: `Requested ${additional_workers} workers for ${shift_ids.length} shifts`,
        shifts: shift_ids.map((shiftId) => {
          const shift = updatedShifts.find((s) => s.id === shiftId) as WorkShift
          return {
            id: shiftId,
            workersNeeded: (shift.workersNeeded ?? 0) + additional_workers,
            numOpenSpots: (shift.numOpenSpots ?? 0) + additional_workers, // Add to existing numOpenSpots
          }
        }),
      },
    }
  },
}
